export default __webpack_public_path__ + "static/media/infografico_3_estratégias.e21c3f83.png";